export const iconFontAwesomeEmojiFaceGrinSquintTears = (
	<i className="fa-solid fa-face-grin-squint-tears"></i>
);
